// extracted by mini-css-extract-plugin
export default {"chart":"TopFormation_chart__ph9fV"};